import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchQuoteRequestLinesBulk } from "./fetchQuoteRequestLinesBulk.api";

export const quoteRequestLinesBulkQuery = ({ ids }: { ids: string[] }) => ({
  queryKey: queryKeys.quoteRequestLines.bulk(ids),
  queryFn: () => fetchQuoteRequestLinesBulk({ ids }),
  staleTime: STALE_TIME,
  enabled: ids.length > 0,
});
